import { api } from './base';

import { MutationArg } from 'v2/types';
import { SWRKeyValue } from 'v2/types/swr';
import { exportFile, getFileNameFromDispositionHeader } from 'v2/utils';

interface BulkCreateChanceTicketsBody {
  userId: string;
  entityId: string;
  quantity: number;
}

export const chanceTicketService = {
  bulkCreate(_key: string, { arg }: MutationArg<BulkCreateChanceTicketsBody>): Promise<void> {
    return api.post('v1/admin/chance-ticket/bulk', { json: arg }).then(() => undefined);
  },

  exportUsers([_key, entityId]: SWRKeyValue): Promise<void> {
    return api.get(`v1/admin/chance-ticket/${entityId}/export/users`).then(async (response) => {
      const blob = await response.blob();
      const disposition = response.headers.get('content-disposition');
      const fileName = getFileNameFromDispositionHeader(disposition, `contest_ticket_${entityId}_users.xlsx`);

      exportFile(blob, fileName);
    });
  },

  exportTickets([_key, entityId]: SWRKeyValue): Promise<void> {
    return api.get(`v1/admin/chance-ticket/${entityId}/export/tickets`).then(async (response) => {
      const blob = await response.blob();
      const disposition = response.headers.get('content-disposition');
      const fileName = getFileNameFromDispositionHeader(disposition, `contest_ticket_${entityId}_chance_tickets.xlsx`);

      exportFile(blob, fileName);
    });
  },
};
